import { EGameType } from '../types/enums'
import { HandEvaluator } from '.'

export const evaluateCards = (playerCards: string, communityCards: string) => {
  const playerCardsArray = playerCards?.split?.(' ') || []
  const communityCardsArray = communityCards.split(' ')

  return HandEvaluator.evaluate(
    playerCardsArray.map((card) => card.split('').reverse().join('')),
    communityCardsArray.map((card) => card.split('').reverse().join('')),
    playerCardsArray.length === 2
      ? EGameType.NLH
      : playerCardsArray.length === 4
        ? EGameType.PLO4
        : EGameType.PLO5,
  )
}
